import styled, { keyframes } from 'styled-components';
import device from '../../utils/mediaQuery';
import { GREY_2, WHITE } from "../../utils/colors";
import cloudBgImage from '../../assets/images/cloud-bg-image.jpg';
import busBgImage from '../../assets/images/bus-bg-image.jpg';

export const Wrapper = styled.div<{ $tripType?: string }>`
  min-height: 100vh;
  position: relative;
  background: #fafafa url(${({ $tripType }) => $tripType === 'road' ? busBgImage : cloudBgImage}) no-repeat bottom center;
  background-size: 100% auto;

  @media ${device.large} {
    padding: 0 0 150px;
  }

  .ant-drawer-title {
    font-size: 20px;
  }

  .ant-modal-footer, .ant-drawer-footer {
    padding: 30px;
  }

  .ant-drawer-content-wrapper {
    height: 92vh !important;
  }

  @media ${device.large} {
    .ant-drawer-content-wrapper {
      width: 520px !important;
      height: unset !important;
    }
  }
`;

export const MobileContentContainer = styled.div`
    padding-bottom: 160px;
    background: ${GREY_2};
`;

export const MobileContentWrapper = styled.div`
  padding: 24px 20px 5px;
  background: ${WHITE};
`;

export const DesktopContentWrapper = styled.div`
  margin-top: 40px;
`;

export const ContentWrapper = styled.div`
  @media ${device.large} {
    padding: 15px;
    background: #fff;
  }
`;

export const ActionContentWrapper = styled.div`
  display: flex;
  column-gap: 40px;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0 16px;

  @media ${device.large} {
    display: block;
  }
`;

export const TermsWrapper = styled.div`
  background: ${WHITE};
  padding: 16px;
  margin-bottom: 10px;
`;

export const ActionWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: 20px;
  background: ${WHITE};
  z-index: 100;

  @media ${device.large} {
    position: unset;
    border: none;
    padding-top: 10px;
  }
`;

export const Space = styled.div`
  height: 25px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
`;


export const BookingFooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 15px;
  padding: 16px;
`;

export const BookingFailedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  text-align: center;
  max-width: 480px;
  margin: 60px auto;
  background: #ffffff;
  border-radius: 24px;

  @media ${device.large} {
    margin: 80px auto;
    padding: 48px 32px;
    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.06);
    border: 1px solid #f2f4f7;
  }
`;

export const StatusIcon = styled.img`
  width: 120px;
  height: 120px;
  margin-bottom: 24px;
`;

export const StatusTitle = styled.h2`
  font-family: 'SF Pro', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #0c111d;
  margin-bottom: 12px;
  line-height: 38px;
`;

export const StatusDescription = styled.p`
  font-family: 'SF Pro', sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: #475467;
  margin-bottom: 32px;
  padding: 0 10px;
`;

export const FailureButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 12px;
`;

const pulseGlow = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(27, 135, 7, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(27, 135, 7, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(27, 135, 7, 0);
  }
`;

const flowAnimation = keyframes`
  0% {
    left: 0%;
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    left: 100%;
    opacity: 0;
  }
`;

export const MpesaModalLogo = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #1B8707;
  color: #fff;
  font-family: 'Outfit', sans-serif;
  font-size: 32px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border: 3px solid #FFCB05;
  box-shadow: 0 4px 10px rgba(27, 135, 7, 0.2);
`;

export const MpesaLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 32px 0 24px;
`;

export const MpesaLoaderNode = styled.div<{ active?: boolean }>`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${props => props.active ? '#1B8707' : '#F4F5F7'};
  border: 2px solid ${props => props.active ? '#FFCB05' : '#E4E7EC'};
  color: ${props => props.active ? '#fff' : '#667085'};
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  animation: ${props => props.active ? pulseGlow : 'none'} 2s infinite;

  span {
    z-index: 2;
  }
`;

export const MpesaConnectingLine = styled.div`
  width: 80px;
  height: 4px;
  background: #E4E7EC;
  border-radius: 2px;
  position: relative;
  overflow: hidden;

  .dot {
    position: absolute;
    top: 0;
    width: 8px;
    height: 4px;
    background: #1B8707;
    border-radius: 20%;
    animation: ${flowAnimation} 1.5s infinite linear;
  }

  .dot-1 {
    animation-delay: 0s;
  }
  .dot-2 {
    animation-delay: 0.5s;
  }
  .dot-3 {
    animation-delay: 1s;
  }
`;

export const MpesaSpinningLogoWrapper = styled.div`
  margin: 0 auto 24px auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

